import { ASSISTER_FILTERS_TYPES,ASSISTER_FILTER_VALIDATION_TYPES } from '../../../constants/actionTypes/entityActionTypes';
import { fields } from '../../../constants/entity/entityConfig';

export const INITIAL_STATE = {
    [fields.ENTITY_NAME] : { type:'text', value : '', isVisible : false, message : 'Please enter a valid entity name.' },
    [fields.ENTITY_FEDERAL_TAX_ID]: { type:'text', value : '', values : [], isVisible : false, message : 'Please enter a valid entity federal tax id ' },
    [fields.CEC_FIRST_NAME] : { type : 'text',value : '', isVisible : false, message : 'Please enter a valid first name' },
    [fields.CEC_LAST_NAME] : { type:'text', value : '', isVisible : false, message : 'Please enter a valid last name' },
    [fields.CEC_LICENCE_NUMBER] : { type:'text', value : '', isVisible : false, message : 'Please enter a valid certification number' }
};

export default (state= INITIAL_STATE, action = {}) => {
    switch(action.type) {
        case ASSISTER_FILTERS_TYPES.INIT_ALL_FILTERS: {
            // Ohh... So innovative way of doing nothing. TODO: get rid of it one day
            return  { ...state };
        }
        case ASSISTER_FILTERS_TYPES.SET_FILTER_VALUE: {            
            const fieldName = action.newFilterValue.fieldName;
            const fieldValue = action.newFilterValue.fieldValue;
            return { ...state, [fieldName] : { ...state[fieldName] , value : fieldValue }
            };
        }
        case ASSISTER_FILTERS_TYPES.RESET_FILTER_VALUES: {
            return INITIAL_STATE;

        }        
        case ASSISTER_FILTER_VALIDATION_TYPES.SET_FILTER_FORM_STATE : {
            return { ...state, [fields.CEC_EMAIL] : { ...state[fields.CEC_EMAIL] , isVisible : action.filterValidationObj[fields.CEC_EMAIL].isVisible  } };
        }

        default:
            return state;
    }
};